import '@babel/polyfill' //(一定要在最上面，第一行)
// core-js 是一个 JavaScript 的 polyfill 库
// 提供了最新的 ECMAScript 功能在旧版浏览器中的实现
import 'core-js/stable';
// 这是用来支持 async/await 语法的运行时环境
import 'regenerator-runtime/runtime';
import 'animate.css';
import Vue from 'vue'
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/icon.css'
//引入vue-router
// import "swiper/swiper-bundle.css";

import router from './router/index'  //刚刚建立的文件夹
import VueRouter from 'vue-router'
import App from './App.vue'
// 将自动注册所有组件为全局组件
// import dataV from '@jiaminghi/data-view'
//引入rem.js
import '@/assets/js/flexible.js';
// //引入组件
import Component from '@/utils/index.js'

Vue.prototype.imgurl = "https://api.jxchanglipeixun.com";
Vue.prototype.uploadimg = "https://api.jxchanglipeixun.com/api/index/uploadfile"
// Vue.prototype.uploadfile = ""
//时间过滤
import filter from '@/utils/filter/data'
Vue.prototype.$formatTimestamp = filter.formatTimestamp;
//全局过滤器 秒
Vue.filter('formatTimestamp', filter.formatTimestamp)
//引入API
import API from '@/request/api';
Vue.prototype.$api = API;

//使用dataV
// Vue.use(dataV)
//使用element-ui
Vue.use(ElementUI);
//使用vue-router
Vue.use(VueRouter)
// //全局注册组件
Vue.use(Component)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
